import { Sucursal } from "@/services/accounts.service";
import { z } from "zod";

export interface ActiveDirectoryUser {
  id: string;
  displayName: string;
  givenName: string;
  surname: string;
  userPrincipalName: string;
  mail: string;
}

export interface Permiso {
  id: number;
  descripcion: string;
  codigo: string
  tipoPermiso: string
}

export interface Rol {
  id: number;
  nombre: string;
  permisos: Permiso[];
  fechaCreacion: string;
  fechaModificacion: string;
  activo: boolean;
}

export interface BOUser {
  id: number;
  usuario: string;
  nombreApellido: string;
  sucursales: Sucursal[];
  roles: Rol[];
}

export const roleFilterSchema = z.object({
  user_name: z.boolean().optional(),
  full_name: z.string().optional(),
  assignated_roles: z.array(z.any()).optional(),
});

export const roleAssignationSchema = z
  .object({
    user: z.any().optional(),
    roles: z.array(z.number()).optional(),
    full_name: z.any().optional(),
    mail: z.any().optional(),
    sucursales: z.array(z.any().optional()).optional(),
  })
  .superRefine((data, ctx) => {
    if (Number(data?.user?.length) < 1) {
      ctx.addIssue({
        path: ["user"],
        code: "custom",
        message: "El campo es requerido",
      });
    }

    if (Number(data?.roles?.length) < 1) {
      ctx.addIssue({
        path: ["roles"],
        code: "custom",
        message: "Se debe elegir al menos un rol.",
      });
    }

    if (Number(data?.sucursales?.length) < 1) {
      ctx.addIssue({
        path: ["sucursales"],
        code: "custom",
        message: "Se debe elegir al menos una sucursal.",
      });
    }
  });
